export default __webpack_public_path__ + "static/media/640_dummy2016-asia-restaurant01-de.11c24240.png";